export default {
	CREATE_SCHEDULE_FOLLOWER(state, follower) {
		state.followers.push(follower);
	},
	UPDATE_SCHEDULE_FOLLOWER(state, updatedFollower) {
		const index = state.followers.findIndex((follower) => follower.id === updatedFollower.id);
		if (index !== -1) {
			state.followers.splice(index, 1, updatedFollower);
		}
	},
	DELETE_SCHEDULE_FOLLOWER(state, followerId) {
		state.followers = state.followers.filter((follower) => follower.id !== followerId);
	},
	SET_TEMPLATES(state, templates) {
		state.templates = templates;
	},
	SET_SCHEDULE_FOLLOWERS(state, followers) {
		state.followers = followers;
	},
};
